import { Button, Spinner, Typography } from '@material-tailwind/react'
import { Modal } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { errorToast } from '../../components/toasts/toasts'
import { baseApi } from '../../ConfigApi'
import { blobToBase64 } from '../../utils/utils'
import CloseDrawerIcon from '../../images/icons/CloseDrawerIcon'
import { useParams } from 'react-router-dom'


type PropsModal = {
    open: boolean,
    handleClose: any,
    formSend: any,
}
const ModalViewPdf = ({
    open,
    handleClose,
    formSend,
}: PropsModal) => {

    const { t } = useTranslation()

    const { param_contract_id } = useParams()

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [frameFile, setFrameFile] = useState<any>(null);
    const [isError, setIsError] = useState<boolean>(false);

    const handleDownloadFile = (formSend: any) => {
        setIsLoading(true)
        setIsError(false)
        axios.post(`${baseApi}/api/acts/export-file`, { ...formSend, contract_id: Number(param_contract_id) }, { responseType: 'blob' })
            .then((response: any) => {
                if (response.data.res === 'error') {
                    setIsError(true)
                }
                else {
                    blobToBase64(response.data).then((res: any) => {
                        setFrameFile(res)
                    });
                }
            })
            .catch(error => {
                console.error(error);
                setIsError(true)
                errorToast({
                    title: t('acts_page.acts_title'),
                    text: t('error_on_download')
                })
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    useEffect(() => {
        if (open && formSend) handleDownloadFile(formSend)
        return () => {
            setFrameFile(null)
            setIsError(false)
            setIsLoading(true)
        };
    }, [open, formSend]);

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='flex items-center justify-center'
            >
                <div className={`
                    w-[calc(100vw-16px)] tab:w-[700px] lap:w-[1200px]
                    flex justify-center items-center transition-all 
                `}>
                    {
                        isLoading ?
                            <Spinner />
                            :
                            frameFile ?
                                <div className='w-full my-[16px] animate-appear' style={{ animationDuration: '.4s' }}>
                                    <div className='flex justify-end items-center mb-[16px]'>
                                        <div onClick={handleClose} className="bg-white rounded-full w-[32px] h-[32px] transition-all flex items-center justify-center active:bg-gray-200 hover:bg-gray-100 cursor-pointer">
                                            <CloseDrawerIcon />
                                        </div>
                                    </div>
                                    <iframe src={frameFile} className='h-[90vh] w-full' />
                                </div>

                                :
                                isError ?
                                    <div className='bg-white p-[36px] rounded-[12px] flex flex-col items-center gap-[24px]'>
                                        <Typography variant='lead' className='text-[20px] font-bold'>
                                            {t('error_on_load_try_again')}
                                        </Typography>
                                        <Button color='white' onClick={() => handleDownloadFile(formSend)}>
                                            {t('reload')}
                                        </Button>
                                    </div>
                                    :
                                    ''
                    }
                </div>
            </Modal>
        </div>
    )
}

export default ModalViewPdf
